<template>
  <el-card shadow="never" :body-style="{padding: '5px'}">
    <div class="G_Field">
      <div class="Label h_link">
        热门城市：
      </div>
      <div class="Fields">
        <router-link to="lists?cid=110000" class="top_link">北京</router-link>
        <router-link to="lists?cid=310000" class="top_link">上海</router-link>
        <router-link to="lists?cid=440100" class="top_link">广州</router-link>
        <router-link to="lists?cid=440300" class="top_link">深圳</router-link>
        <router-link to="lists?cid=330100" class="top_link">杭州</router-link>
        <router-link to="lists?cid=320100" class="top_link">南京</router-link>
        <router-link to="lists?cid=510100" class="top_link">成都</router-link>
        <router-link to="lists?cid=500000" class="top_link">重庆</router-link>
        <router-link to="lists?cid=420100" class="top_link">武汉</router-link>
        <router-link to="lists?cid=120000" class="top_link">天津</router-link>
      </div>
    </div>
    <div class="G_Field" v-if="show">
      <div class="Label h_link">
        东北华北：
      </div>
      <div class="Fields">
        <router-link to="lists/?cid=110000" class="hot_link">北京市</router-link>
        <router-link to="lists/?cid=120000" class="hot_link">天津市</router-link>
        <router-link to="lists/?cid=370000" class="hot_link">山东省</router-link>
        <router-link to="lists/?cid=130000" class="hot_link">河北省</router-link>
        <router-link to="lists/?cid=140000" class="hot_link">山西省</router-link>
        <router-link to="lists/?cid=150000" class="hot_link">内蒙古</router-link>
        <router-link to="lists/?cid=210000" class="hot_link">辽宁省</router-link>
        <router-link to="lists/?cid=230000" class="hot_link">黑龙江</router-link>
        <router-link to="lists/?cid=220000" class="hot_link">吉林省</router-link>
      </div>
    </div>
    <div class="G_Field" v-if="show">
      <div class="Label h_link">
        华中华东：
      </div>
      <div class="Fields">
        <router-link to="lists/?cid=310000" class="hot_link">上海市</router-link>
        <router-link to="lists/?cid=320000" class="hot_link">江苏省</router-link>
        <router-link to="lists/?cid=330000" class="hot_link">浙江省</router-link>
        <router-link to="lists/?cid=350000" class="hot_link">福建省</router-link>
        <router-link to="lists/?cid=410000" class="hot_link">河南省</router-link>
        <router-link to="lists/?cid=420000" class="hot_link">湖北省</router-link>
        <router-link to="lists/?cid=430000" class="hot_link">湖南省</router-link>
        <router-link to="lists/?cid=340000" class="hot_link">安徽省</router-link>
        <router-link to="lists/?cid=360000" class="hot_link">江西省</router-link>
      </div>
    </div>
    <div class="G_Field" v-if="show">
      <div class="Label h_link">
        西北西南：
      </div>
      <div class="Fields">
        <router-link to="lists/?cid=500000" class="hot_link">重庆市</router-link>
        <router-link to="lists/?cid=510000" class="hot_link">四川省</router-link>
        <router-link to="lists/?cid=530000" class="hot_link">云南省</router-link>
        <router-link to="lists/?cid=520000" class="hot_link">贵州省</router-link>
        <router-link to="lists/?cid=610000" class="hot_link">陕西省</router-link>
        <router-link to="lists/?cid=620000" class="hot_link">甘肃省</router-link>
        <router-link to="lists/?cid=630000" class="hot_link">青海省</router-link>
        <router-link to="lists/?cid=650000" class="hot_link">新疆</router-link>
        <router-link to="lists/?cid=640000" class="hot_link">宁夏</router-link>
        <router-link to="lists/?cid=540000" class="hot_link">西藏</router-link>
      </div>
    </div>
    <div class="G_Field" v-if="show">
      <div class="Label h_link">
        华南港澳：
      </div>
      <div class="Fields">
        <router-link to="lists/?cid=440000" class="hot_link">广东省</router-link>
        <router-link to="lists/?cid=450000" class="hot_link">广西</router-link>
        <router-link to="lists/?cid=460000" class="hot_link">海南省</router-link>
        <router-link to="lists/?cid=810000" class="hot_link">香港</router-link>
        <router-link to="lists/?cid=820000" class="hot_link">澳门</router-link>
        <router-link to="lists/?cid=830000" class="hot_link">台湾</router-link>
      </div>
    </div>
    <div class="c-btn">
      <el-button round size="mini" @click="show = !show, button(show)">{{button_value}}</el-button>
    </div>
  </el-card>
</template>

<script>
export default {
  name: 'HotCity',
  data () {
    return {
      show: false,
      button_value: '+更多区域'
    }
  },
  methods: {
    button (show) {
      if (show === true) {
        this.button_value = '-收起'
      } else {
        this.button_value = '+更多区域'
      }
    }
  }
}
</script>

<style scoped>
  .G_Field {
    display: flex !important;
    border-radius: .25rem !important;
  }

  .hot_link {
    font-size: 14px;
    word-break: keep-all;
    color: #666;
    text-decoration: none;
    padding-top: 5px;
    padding-bottom: 5px;
    flex: 0 0 25%;
    max-width: 25%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
  .top_link {
    font-size: 14px;
    word-break: keep-all;
    color: #666;
    text-decoration: none;
    padding-top: 5px;
    padding-bottom: 5px;
    flex: 0 0 16.66667%;
    max-width: 16.66667%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: left;
  }
  @media (min-width: 576px) {
    .hot_link{
      flex: 0 0 25%;
      max-width: 25%;
    }
  }

  @media (min-width: 768px) {
    .hot_link{
      flex: 0 0 16.66667%;
      max-width: 16.66667%;
    }
    .top_link{
      flex: 0 0 16.66667%;
      max-width: 16.66667%;
    }
  }

  @media (min-width: 992px) {
    .hot_link{
      flex: 0 0 10%;
      max-width: 10%;
    }
    .top_link{
      flex: 0 0 10%;
      max-width: 10%;
    }
  }

  .h_link {
    font-size: 14px;
    word-break: keep-all;
    color: #666;
    text-decoration: none;
    margin: 5px;
    width: 85px;
  }

  @media (max-width: 768px) {
    .hot_link {
      width: 70px;
    }
  }

  .Label {
    font-weight: 700;
  }

  .Fields {
    flex-wrap: wrap;
    display: flex;
    flex: 1 1;
  }

</style>



// WEBPACK FOOTER //
// src/components/widget/hotcity.vue